import gql from 'graphql-tag'

export const USUARIO_QUERY = gql`
  query usuarioQuery($id: ID!) {
    usuario(id: $id) {
      id
      nome
      email
      cpf
      tipoDocumento {
        id
        description
      }
      isEstrangeiro
      tiposAcesso {
        id
        nome
        produto {
          id
        }
      }
      funcionalidades {
        id
        produto {
          id
        }
      }
      tipo {
        id
        description
      }
      idioma {
        id
      }
      marcas {
        id
      }
      telefones
      celulares
      grupos {
        id
      }
      dealers {
        id
        active
        nomeExibicao
        grupo {
          id
        }
      }
    }
  }
`
